import { styled } from '@linaria/react';

export const TabButton = styled.button<{ size: 'S' | 'M'; selected?: boolean }>`
	display: flex;
	min-width: 100px;
	max-width: 240px;
	flex: 1;
	align-items: center;
	justify-content: center;
	padding: ${({ size }) => (size === 'S' ? '0.8rem 0.6rem' : '1.6rem 0.8rem')};
	border-bottom: solid transparent
		${({ size }) => (size === 'S' ? '0.1rem' : '0.2rem')};
	border-bottom-color: ${({ selected = false }) =>
		selected ? 'var(--color-white-solid)' : 'transparent'};
	color: ${({ selected = false }) =>
		selected ? 'var(--color-white-solid)' : 'var(--color-grey-68-solid)'};
	text-transform: capitalize;
	transition: border-bottom-color var(--button-transition-duration) ease-in-out,
		color var(--button-transition-duration) ease-in-out;

	&:hover {
		border-color: var(--color-white-solid);
		color: var(--color-white-solid);
	}
`;

export const Container = styled.div`
	display: flex;
	justify-content: center;
	gap: 4px;
`;

export const Title = styled.span<{ size: 'S' | 'M' }>`
	font-size: ${({ size }) =>
		size === 'M' ? 'var(--font-size-2xl)' : 'var(--font-size-m)'};
`;
